import { CLOUD_FUNCTION_URLS, type EnvMode } from '@be-link/cos';

export type CosUploader = {
	uploadFile: (
		file: File,
		config?: {
			Key?: string;
			ContentType?: string;
			Headers?: Record<string, string>;
		},
	) => Promise<unknown>;
};

async function assertCosTempSecretAvailable(mode: EnvMode) {
	const url = CLOUD_FUNCTION_URLS[mode];
	const response = await fetch(url, { method: 'POST' });
	const data = (await response.json().catch(() => null)) as
		| { message?: string }
		| null;

	if (!response.ok) {
		throw new Error(
			data?.message
				? `COS 临时密钥接口拒绝访问：${data.message}`
				: `COS 临时密钥接口请求失败，状态码：${response.status}`,
		);
	}
}

export async function uploadTextToCosPath(
	cosUploader: CosUploader,
	params: {
		path: string;
		body: string;
		contentType: string;
		mode?: EnvMode;
	},
) {
	const mode = params.mode || 'production';
	await assertCosTempSecretAvailable(mode);

	const key = params.path.replace(/^\/+/u, '');
	const file = new File([params.body], 'config.json', {
		type: params.contentType,
	});

	await cosUploader.uploadFile(file, {
		Key: key,
		ContentType: params.contentType,
		Headers: {
			'Content-Type': params.contentType,
		},
	});
}
